@if ($expressionService.isEnabled()) {
  <img class="absolute top-0 w-full" src="/curtain-top.png" alt="" animate.enter="anim-slide-from-top" animate.leave="anim-slide-to-top" />
  <img
    class="absolute -left-8 h-full"
    src="/curtain-side.png"
    alt=""
    animate.enter="anim-slide-from-left"
    animate.leave="anim-slide-to-left"
  />
  <div class="absolute -right-8 h-full" animate.enter="anim-slide-from-right" animate.leave="anim-slide-to-right">
    <img class="flip-x h-full" src="/curtain-side.png" alt="" />
  </div>
}

<!-- expression dice -->
<rid-dice-slot
  [value]="$expressionService.tutorExpression()"
  class="absolute bottom-4 left-4"
  color="PINK"
  [togglable]="$expressionService.isTutorExpressionAvailable()"
  (toggled)="toggleExpression('TUTOR')"
/>
<rid-dice-slot
  [value]="$expressionService.clientExpression()"
  class="absolute right-4 bottom-4"
  color="BLUE"
  [togglable]="$expressionService.isClientExpressionAvailable()"
  (toggled)="toggleExpression('CLIENT')"
/>
